import { render, staticRenderFns } from "./TingWuVideoTask.vue?vue&type=template&id=7ef2fdda&scoped=true"
import script from "./TingWuVideoTask.vue?vue&type=script&lang=js"
export * from "./TingWuVideoTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef2fdda",
  null
  
)

export default component.exports